import React from "react";
import Slider from "react-slick";



const WorkSlider = () => {

  
  const expsettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 1200,

    slidesToShow: 5,
    arrows:true,
    slidesToScroll: 1,
    // nextArrow: <CustomNextArrow />,
    //   prevArrow: <CustomPrevArrow />,
    nextArrow: false,
    prevArrow: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const categories = [
    
    {
      logo:'https://glocify.com/images/petparent.png',
      title:'Petparentsbrand',
      desc:'We power their entire payment system with Stripe, seamlessly integrating their eCommerce store and POS app.'
    },
    {
      logo:'https://glocify.com/images/polarity.png',
      title:'Polarity Digital',
      desc:'We implemented recurring subscriptions using Stripe, providing a seamless subscription experience.'
    },
    {
      logo:'https://glocify.com/images/activity.png',
      title:'Activityhub',
      desc:'We power this marketplace with Stripe Connect, ensuring smooth management of vendor payments and commissions.'
    },
    {
      logo:'https://glocify.com/images/foodie.png',
      title:'Foodieland',
      desc:'We developed a custom POS application that processes payments using M2, BBPOS WisePad, and S700 readers.'
    },
    {
      logo:'https://glocify.com/images/saychesesoker.png',
      title:'SayCheeseKosher',
      desc:'We built their website on WooCommerce and integrated Stripe to power their payment processing.'
    },
  ];

  return (
    <>
          <style>
        {`
         
.experienceSlider button.slick-arrow.slick-next {
  display: block !important;
  width: 90px;
  height: 90px;
  background: url('https://glocify.com/images/next.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  transform:translate(20px, -40px);
}
.experienceSlider button.slick-arrow.slick-prev {
  display: block !important;
  width: 90px;
  height: 90px;
  background: url('https://glocify.com/images/prev.svg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
    transform:translate(-20px, -40px);
}
 .experienceSlider   .slick-arrow:hover{opacity:.6;}
  .experienceSlider  .slick-arrow{z-index:99;}
 .experienceSlider  .slick-arrow:before{opacity:0;}
        `}
      </style>
    <div className="slider-container experienceSlider lg:px-[60px] px-[30px]">
      <Slider {...expsettings}>
        {categories.map((category, index) => (
          <div key={index} className="p-5 ">
         <div className="rounded-[32px] overflow-hidden shado" style={{boxShadow:'1px -1px 31px -11px rgba(0,0,0,.2)'}}>
            <div className="bg-[#F9F9FD] pb-[60%] relative"><img style={{objectFit:'contain', objectPosition:'center',scale:'.6', transformOrigin:'center'}} className=" absolute left-0 top-0 w-[100%] h-[100%]" src={category.logo} alt="clients"/></div>
            <div className="text-center px-[23px] py-[20px]"> 
              {/* <h3 className="text-left text-[24px] font-bold text-[#262626] tracking-tight mb-1">{category.title}</h3> */}
              <p className="text-left text-[15px] text-[#262626] min-h-[100px] tracking-tight">{category.desc}</p>
            </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>   
    </>
  );
};

export default WorkSlider;
